/**
 * Brand: Ekin nav header used across Dashboard / Metrics / Admin.
 * Keeps logo + tagline consistent with the login page.
 */
export const EKIN_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_delivery-status-30/artifacts/fgciba1d_ekin_logo_HR.png";

export default function EkinBrand({ subtitle = "Sistema de entregas" }) {
  return (
    <div className="flex items-center gap-3" data-testid="ekin-brand">
      <img src={EKIN_LOGO_URL} alt="EKIN" className="h-8 sm:h-9 w-auto object-contain" />
      <div className="hidden sm:block border-l border-zinc-200 pl-3">
        <p className="text-[10px] uppercase tracking-[0.22em] font-medium text-ekin-600">
          {subtitle}
        </p>
        <p className="text-[9px] uppercase tracking-[0.28em] text-zinc-400 mt-px">
          Thinking together
        </p>
      </div>
    </div>
  );
}
